import {
    HL_SUPPLIER,
    HL_SUPPLIER_SUCCESS,
    HL_SUPPLIER_ERROR,
    HL_CATEGORY,
    HL_CATEGORY_SUCCESS,
    HL_CATEGORY_ERROR,
    HL_LIST,
    HL_LIST_SUCCESS,
    HL_LIST_ERROR,
    HL_LIST_SEARCH_CHANGE,
    HL_LIST_PAGE_SET,
    HL_ADD_MODAL_SET,
    HL_ADD_CHANGE_SET,
    HL_ADD,
    HL_ADD_SUCCESS,
    HL_ADD_ERROR,
    HL_EDIT_MODAL_SET,
    HL_EDIT_CHANGE_SET,
    HL_EDIT,
    HL_EDIT_SUCCESS,
    HL_EDIT_ERROR,
    HL_UPLOAD_SET,
    HL_UPLOAD_SET_SUCCESS,
    HL_UPLOAD_SET_ERROR,
    HL_UPLOAD_RESET,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    supplier: {
        loading: false,
        data: []
    },
    category: {
        loading: false,
        data: []
    },
    add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    file: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            supplier: '',
            category: '',
            status: ''
        },
        value: {
            supplier: '',
            category: '',
            status: ''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case HL_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case HL_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case HL_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HL_CATEGORY:
            return {
                ...state,
                loading: true,
                category: {
                    ...state.category
                }
            }
        case HL_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                category: {
                    ...state.category,
                    ...action.payload
                }
            }
        case HL_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HL_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case HL_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HL_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case HL_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case HL_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case HL_ADD_MODAL_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: action.payload
                }
            }
        case HL_ADD_CHANGE_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        ...action.payload
                    }
                }
            }
        case HL_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false
                }
            }
        case HL_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HL_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case HL_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case HL_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case HL_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case HL_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HL_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case HL_UPLOAD_SET:
            return { ...state };

        case HL_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case HL_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case HL_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };


        default:
            return { ...state };
    }
};